import type { KeyboardEvent, ReactNode } from 'react';

export function TabList({
    label,
    className,
    children,
}: {
    label: string;
    className?: string;
    children: ReactNode;
}) {
    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        const tabs = Array.from(
            event.currentTarget.querySelectorAll<HTMLElement>('[role="tab"]:not([disabled])'),
        );
        const currentIndex = tabs.findIndex((tab) => tab === document.activeElement);

        if (currentIndex < 0 || tabs.length === 0) return;

        let nextIndex: number | null = null;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== null) {
            event.preventDefault();
            tabs[nextIndex]?.focus();
        }
    };

    return (
        <div role="tablist" aria-label={label} className={className} onKeyDown={handleKeyDown}>
            {children}
        </div>
    );
}

export function getTabProps({
    id,
    panelId,
    selected,
}: {
    id: string;
    panelId: string;
    selected: boolean;
}) {
    return {
        id,
        role: 'tab' as const,
        'aria-selected': selected,
        'aria-controls': panelId,
        tabIndex: selected ? 0 : -1,
    };
}
